import { render, staticRenderFns } from "./RelatedStrategyProjects.vue?vue&type=template&id=5b6fdf29&scoped=true"
import script from "./RelatedStrategyProjects.vue?vue&type=script&lang=js"
export * from "./RelatedStrategyProjects.vue?vue&type=script&lang=js"
import style0 from "./RelatedStrategyProjects.vue?vue&type=style&index=0&id=5b6fdf29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fdf29",
  null
  
)

export default component.exports